import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Button, Tag, Popconfirm, Row, Col } from 'antd';
import { EditOutlined, CloseCircleOutlined } from '@ant-design/icons';
import moment from 'moment';

const SubscriptionTable = ({
  subscriptions,
  handleEditSubscription,
  handleCancelSubscription,
  subPage,
  subPerPage,
  handleSubscriptionPageChange,
  role,
}) => {
  const { t } = useTranslation();
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'active':
        return { color: 'green', label: t('subscriptions.active') };
      case 'cancelled':
        return { color: 'red', label: t('subscriptions.cancelled') };
      case 'pending':
        return { color: 'gray', label: t('subscriptions.pending') };
      case 'expired':
        return { color: 'orange', label: t('subscriptions.expired') };
      default:
        return { color: 'black', label: t('subscriptions.unknown') };
    }
  };

  const getTypeColor = (type) => {
    switch (type.toLowerCase()) {
      case 'prepaid':
        return '#28a745';
      case 'postpaid':
        return '#007bff';
      case 'monthly':
        return '#fd7e14';
      default:
        return 'black';
    }
  };

  const columns = [
    {
      title: t('subscriptions.paymentType'),
      dataIndex: 'paymentType',
      key: 'paymentType',
      render: (paymentType) => (
        <Tag color={getTypeColor(paymentType)}>{paymentType.toUpperCase()}</Tag>
      ),
    },
    {
      title: t('subscriptions.startTime'),
      dataIndex: 'startTime',
      key: 'startTime',
      render: (startTime) =>
        moment(startTime).local().format('DD.MM.YYYY HH:mm'),
    },
    {
      title: t('subscriptions.endTime'),
      dataIndex: 'endTime',
      key: 'endTime',
      render: (endTime) =>
        endTime ? moment(endTime).local().format('DD.MM.YYYY HH:mm') : '/',
    },
    {
      title: t('subscriptions.status'),
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const { color, label } = getStatusColor(status);
        return <Tag color={color}>{label.toUpperCase()}</Tag>;
      },
    },
  ];

  if (role === 'root') {
    columns.push({
      title: t('subscriptions.actions'),
      key: 'actions',
      render: (_, record) => (
        <div className="flex gap-2">
          {(record.status === 'active' || record.status === 'pending') && (
            <Row gutter={8}>
              <Col>
                <Button
                  type="primary"
                  ghost
                  icon={<EditOutlined />}
                  onClick={() => handleEditSubscription(record)}
                >
                  {t('common.edit')}
                </Button>
              </Col>
              <Col>
                <Popconfirm
                  title={t('subscriptions.confirmCancel')}
                  onConfirm={() => handleCancelSubscription(record.id)}
                  okText={t('common.yes')}
                  cancelText={t('common.no')}
                >
                  <Button type="danger" danger>
                    <CloseCircleOutlined /> {t('common.cancel')}
                  </Button>
                </Popconfirm>
              </Col>
            </Row>
          )}
        </div>
      ),
    });
  }

  return (
    <>
      <Table
        columns={columns}
        dataSource={subscriptions.subscriptions}
        pagination={{
          current: subPage,
          pageSize: subPerPage,
          total: subscriptions.count,
          onChange: (pageNumber) => handleSubscriptionPageChange(pageNumber),
        }}
      />
    </>
  );
};

export default SubscriptionTable;
